<div role="dialog" aria-describedby="dialogDescription" class="guts-p-full-2">
  <div class="guts-p-b-1" id="dialogDescription">{{ bodyText }}</div>

  <button
    class="full-width"
    df-button
    dfButtonType="primary"
    dgxAutofocus
    (click)="close()"
    data-dgat="sessionTimeoutModal-220"
  >
    {{ buttonText }}
  </button>
</div>
